import { ModalBase } from '@repo/ui';
import Lottie from 'react-lottie';

import animationData from '../../../../animation/archived-1730117598376.json';

interface IProps {
  isOpen: boolean;
  handleDelete: () => void;
  goBack: () => void;
  loading: boolean;
}
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const ModalArchive = ({
  goBack,
  handleDelete,
  isOpen,
  loading,
}: IProps) => {
  return (
    <ModalBase.Wrapper
      className="text-center"
      loading={loading}
      isOpen={isOpen}
      toggle={() => {
        handleDelete();
      }}
    >
      <ModalBase.Header className="justify-content-center">
        <div
          style={{
            height: 100,
            width: 100,
            display: 'flex',
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Lottie
            options={defaultOptions}
            height={200}
            width={200}
            style={{
              cursor: 'default',
            }}
            // speed={0.5}
          />
        </div>
      </ModalBase.Header>
      <ModalBase.Body>
        <h4 className="mb-3">Arquivar Organização</h4>
        <p className="text-muted mb-4">
          Após o arquivamento, nenhum usuário relacionado a esta organização
          poderá acessar o RADE. Tem certeza de que deseja continuar?
        </p>
      </ModalBase.Body>
      <ModalBase.Footer className="justify-content-center">
        <ModalBase.Actions
          goBack={goBack}
          loading={loading}
          actionBtnType="button"
          actionBtnColor="danger"
          confirmBtnLabel="Arquivar"
          onConfirm={() => handleDelete()}
        />
      </ModalBase.Footer>
    </ModalBase.Wrapper>
  );
};
